import * as Sentry from '@sentry/browser'
import _ from 'lodash'
import { toast } from 'react-toastify'

/** Send error to Sentry. Logs the stacktrace on console if running on dev environment.
 * If a custom message is omitted, shows the exception message on the toast.
 * @err the exception object
 * @contextName a string with the context name of the error
 * @extra args to be sent in context data
 */
export const reportError = (err, contextName = 'error', ...extra) => {
  if (process.env.NODE_ENV === 'development') {
    console.error(err)
  }
  else {
    Sentry.captureException(err, { contexts: { [contextName]: extra } })
  }
}

/** Send error message to Sentry. Logs it on console if running on dev environment.
 * @message  custom error message
 * @contextName a string with the context name of the error
 * @extra args to be sent in context data
 */
export const reportErrorMessage = (message, contextName = 'error', ...extra) => {
  if (process.env.NODE_ENV === 'development') {
    console.error(message)
  }
  else {
    Sentry.captureMessage(message, { contexts: { [contextName]: extra } })
  }
}


/** Shows to the user a toast with the error message sent by the API.
 * The toasted message will be fetched from Axios error response. If not available
 * prints a default user defnined message.
 * @errorResponse axios response when an error occurred.
 * @defaultMessage  alternate message if the error response doesn't have one
 */
export const toastifyAxiosError = (errorResponse, defaultMessage = 'Ocorreu um erro ao processar os dados') => {
  const exceptionMessagePath = 'response.data'
  const exceptionMessageAlternatedPath = 'response.data.message'

  const messageError = _.get(errorResponse, exceptionMessagePath) || _.get(errorResponse, exceptionMessageAlternatedPath)
  toast.error((typeof messageError ===  'string') ? messageError : defaultMessage)
}
